import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import logopng from './assets/images/logo.png';
import '../src/components/HeaderMfd.css';

const HeaderMfd = () => {
  const headerRef = useRef(null);
  const productRef = useRef(null);
  const [isProductOpen, setIsProductOpen] = useState(false);

  useEffect(() => {
    const header = headerRef.current;
    const toggleClass = 'is-sticky';

    const handleScroll = () => {
      const currentScroll = window.pageYOffset;

      if (!header) return;

      if (currentScroll > 150) {
        header.classList.add(toggleClass);
      } else {
        header.classList.remove(toggleClass);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (productRef.current && !productRef.current.contains(event.target)) {
        setIsProductOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleProductDropdown = () => {
    setIsProductOpen((prev) => !prev);
  };

  const closeProductDropdown = () => {
    setIsProductOpen(false);
  };

  return (
    <div className="sn-header-main">
      <div
        className="ps-main-wrapper-header sticky-top page-header sticky-top"
        ref={headerRef}
      >
        <header style={{ background: '#faf8f2' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <nav
                  className="navbar navbar-light navbar-expand-md ps-main-nav"
                  style={{ paddingTop: '0' }}
                >
                  <Link to="/">
                    <img
                      src={logopng}
                      alt="Logo"
                      style={{
                        width: '250px',
                        position: 'relative',
                        top: '5px',
                      }}
                    />
                  </Link>

                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasDarkNavbar"
                    aria-controls="offcanvasDarkNavbar"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon" />
                  </button>

                  <div
                    className="offcanvas offcanvas-end text-bg-light"
                    tabIndex={-1}
                    id="offcanvasDarkNavbar"
                    aria-labelledby="offcanvasDarkNavbarLabel"
                  >
                    <div className="offcanvas-header">
                      <button
                        type="button"
                        className="btn-close btn-close-black"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                      />
                    </div>

                    <div className="ps-menu offcanvas-body bt-slidebar">
                      <ul className="navbar-nav justify-content-end flex-grow-1 sn-top-meny-navbar">
                        <li>
                          <a href="/#features">Feature</a>
                        </li>

                        <li>
                          <a href="/#pricing">Pricing</a>
                        </li>

                        <li>
                          <a href="/#upcoming">Upcoming Feature</a>
                        </li>

                        <li>
                          <a href="/#faqs">Faq's</a>
                        </li>

                        <li>
                          <a href="/#contactus">Contact Us</a>
                        </li>

                        <li className={`sn-product-dropdown ${isProductOpen ? 'open' : ''}`} ref={productRef}>
                          <button
                            type="button"
                            className="sn-product-dropdown-toggle"
                            onClick={toggleProductDropdown}
                            aria-expanded={isProductOpen}
                          >
                            Product
                            <i className="fa fa-angle-down" aria-hidden="true"></i>
                          </button>

                          <ul className="sn-product-dropdown-menu">
                            <li>
                              <Link
                                to="/CallNinja"
                                  target="_blank"
                                className="sn-product-dropdown-item"
                                onClick={closeProductDropdown}
                              >
                                Call Ninja
                              </Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
};

export default HeaderMfd;